import { render, staticRenderFns } from "./PermissionDescription.vue?vue&type=template&id=20e160ee&scoped=true"
import script from "./PermissionDescription.vue?vue&type=script&lang=js"
export * from "./PermissionDescription.vue?vue&type=script&lang=js"
import style0 from "./PermissionDescription.vue?vue&type=style&index=0&id=20e160ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e160ee",
  null
  
)

export default component.exports